export default "__VITE_ASSET__Dhm1BGwU__"